<template>
  <div id="app">
    <section>
      <h2>シミュレーションの前提条件<span>（半角数字で入力ください）</span></h2>
      <fieldset id="set_period">
        <legend>積立期間・取り崩し期間の設定</legend>
        <ul>
          <li>
            <label>
              積立開始年齢
              <div class="select_inner">
                <select
                  type="number"
                  name="year"
                  class="start_ages"
                  v-model.number="start_age_temp"
                >
                  <option v-for="n in 53" :value="n + 17" :key="n">
                    {{ n + 17 }}
                  </option>
                </select>
              </div>
              <span>歳</span>
            </label>
          </li>
          <li>
            <label>
              積立終了年齢<br class="SP" />（＝取崩開始年齢）
              <div class="select_inner">
                <select
                  type="number"
                  name="year"
                  class="end_age"
                  v-model.number="end_age_temp"
                >
                  <option
                    v-for="n in 53 - (start_age_temp - 22)"
                    :value="n + start_age_temp"
                    :key="n"
                  >
                    {{ n + start_age_temp }}
                  </option>
                </select>
              </div>
              <span>歳</span>
            </label>
          </li>
          <li>
            <label>
              最終年齢<br class="SP" />（＝取崩終了年齢）
              <div class="select_inner">
                <select
                  type="number"
                  name="year"
                  class="final_age"
                  v-model.number="final_age_temp"
                >
                  <option
                    v-for="n in 53 - (end_age_temp - 47)"
                    :value="n + end_age_temp"
                    :key="n"
                  >
                    {{ n + end_age_temp }}
                  </option>
                </select>
              </div>
              <span>歳</span>
            </label>
          </li>
        </ul>
      </fieldset>
      <fieldset id="set_yield">
        <legend>運用利回りの設定</legend>
        <ul>
          <li>
            <label>
              積立中に期待する利回り<br class="SP" />（上限20%）
              <input
                type="text"
                v-model="expected_yield_temp"
                @input="truncateDecimal('expected_yield_temp', $event)"
                :class="{
                  expected_yield: true,
                  error: this.error_target.indexOf('expected_yield') > -1,
                }"
              />
              <span>%</span>
            </label>
          </li>
          <li>
            <label>
              取崩中に期待する利回り<br class="SP" />（上限20%）
              <input
                type="text"
                v-model="expected_yield_during_reversal_temp"
                @input="
                  truncateDecimal('expected_yield_during_reversal_temp', $event)
                "
                :class="{
                  expected_yield_during_reversal: true,
                  error:
                    this.error_target.indexOf(
                      'expected_yield_during_reversal'
                    ) > -1,
                }"
              />
              <!-- <IntegerStringOnlyInput
                class="expected_yield_during_reversal"
                v-model="expected_yield_during_reversal"
                type="decimal"
              /> -->
              <span>%</span>
            </label>
          </li>
        </ul>
      </fieldset>
      <fieldset id="set_amount">
        <legend>運用資金・取り崩し金額の設定</legend>
        <ul>
          <li>
            <label>
              現時点で準備している老後資金
              <input
                type="number"
                v-model="retirement_funds_temp"
                @input="truncateInteger('retirement_funds_temp', $event)"
                :class="{
                  retirement_funds: true,
                  error: this.error_target.indexOf('retirement_funds') > -1,
                }"
              />
              <span>万円</span>
            </label>
          </li>
          <li>
            <em>公的年金への「自助」での上乗せ(※)</em>
            <label>
              <input
                type="radio"
                name="average_income"
                value="average_income_percent"
                v-model="radiochecked"
              />
              現役時代全期間の平均年収の
              <input
                type="number"
                v-model="average_income_percent_temp"
                @click="onFocus('percent')"
                @input="truncateInteger('average_income_percent_temp', $event)"
                :class="{
                  average_income_percent: true,
                  error:
                    this.error_target.indexOf('average_income_percent') > -1,
                }"
              />
              <span>%</span>
            </label>
            または
            <label>
              <input
                type="radio"
                name="average_income"
                value="average_income_yeary"
                v-model="radiochecked"
              />
              金額（年額）
              <input
                type="number"
                class="average_income_yeary"
                v-model="average_income_yeary_temp"
                @click="onFocus('yeary')"
                @input="truncateInteger('average_income_yeary_temp', $event)"
                :class="{
                  average_income_yeary: true,
                  error: this.error_target.indexOf('average_income_yeary') > -1,
                }"
              />
              <span>万円</span>
            </label>
          </li>
          <li>
            <label>
              現役時代全期間の平均年収
              <input
                type="number"
                max="999999"
                class="average_income_all_periods"
                v-model="average_income_all_periods_temp"
                @input="
                  truncateInteger('average_income_all_periods_temp', $event)
                "
                :class="{
                  average_income_all_periods: true,
                  error:
                    this.error_target.indexOf('average_income_all_periods') >
                    -1,
                }"
              />
              <span>万円</span>
            </label>
          </li>
        </ul>
        <small class="notes"
          >※65歳以降の家計における老後生活費用は、一般的に「現役時代の年収の約7割程度」とも言われています。<br />
          厚生年金保険（厚生年金+基礎年金）の場合は、将来にわたって「現役時代全期間の平均年収」の概ね50%程度を確保するように維持されていますので、自助での「上乗せ金額」に明確なイメージがない方は、自助で「上乗せする比率」として20%程度を目安に検討ください。<br />
          また、自営業の皆様など国民年金（基礎年金）のみの場合には、満額で約78万円（年額）であるため、この金額に対する自助での「上乗せ金額」を検討ください。
        </small>
      </fieldset>

      <p v-if="error != ''" class="error">{{ error }}</p>

      <a @click="expect" class="button calculate">試算する</a>
    </section>
    <section id="expected">
      <h2>必要な保有金融資産額の想定</h2>
      <p>
        「自助」による年金を、年額<span class="self_help">{{
          self_help.toLocaleString()
        }}</span
        >万円（月額<span class="self_help_monthly">{{
          self_help_monthly.toLocaleString()
        }}</span
        >万円）確保するためには、<br />
        積立終了年齢時（<span class="end_age">{{ end_age }}</span
        >歳時点）で<span class="required_amount">{{
          required_amount.toLocaleString()
        }}</span
        >万円の金融資産を準備しておくことが必要です。
      </p>
      <strong>
        <span class="end_age">{{ end_age }}</span
        >歳時点で<span class="required_amount">{{
          required_amount.toLocaleString()
        }}</span
        >万円を準備するには年間<span class="target">{{ target }}</span
        >万円（毎月<span class="target_monthly">{{ target_monthly }}</span
        >万円）の積み立てが必要です。
        <small
          >（前提：積立中に期待する利回りは<span class="expected_yield">{{
            expected_yield
          }}</span
          >%）</small
        >
      </strong>
      <div id="chart">
        <LineChart :data1="amount_array1" :data2="amount_array2" />
      </div>
      <strong>
        運用をしない場合の「資産寿命」
        <span class="longevityWithout">{{ longevityWithout }}</span>
        歳
      </strong>
    </section>
    <section class="investing_effects">
      <h2>積立をしながら運用を行うことの効果</h2>
      <ul>
        <li>
          <span>積立中に運用をすることで<br />想定される収益</span
          ><em
            ><span class="income_in_reserve">{{
              income_in_reserve.toLocaleString()
            }}</span
            >万円</em
          >
        </li>
        <li>
          <span>取り崩し中に運用をすることで<br />想定される収益</span
          ><em
            ><span class="income_under_reversal">{{
              income_under_reversal.toLocaleString()
            }}</span
            >万円</em
          >
        </li>
        <li>
          <span>運用により「資産寿命」を<br />伸ばせる年数</span
          ><em
            ><span class="extended_years">{{ extended_years }}</span
            >年</em
          >
        </li>
      </ul>
    </section>
    <small class="notes"
      >※本シミュレーションは⼊⼒頂いた諸条件を前提にしており、⼿数料・税⾦などを考慮していませんので、計算結果は実際の運⽤成果と異なります。</small
    >
  </div>
</template>

<script>
import LineChart from "./components/LineChart.vue";
// import IntegerStringOnlyInput from "./components/IntegerStringOnlyInput.vue";

export default {
  name: "App",
  components: {
    LineChart,
    // IntegerStringOnlyInput,
  },
  data() {
    return {
      start_age: 30,
      end_age: 65,
      final_age: 100,
      expected_yield: "0",
      expected_yield_during_reversal: "0",
      retirement_funds: "0",
      average_income_percent: "0",
      average_income_yeary: "",
      average_income_all_periods: "0",
      radiochecked: "average_income_percent",
      error: "",
      error_text: [
        "数値を正しく入力してください",
        "0～20％を半角数字で入力してください",
        "1～100％を半角数字で入力してください",
      ],
      error_target: [],
      start_age_temp: 30,
      end_age_temp: 65,
      final_age_temp: 100,
      expected_yield_temp: "3",
      expected_yield_during_reversal_temp: "2",
      retirement_funds_temp: "0",
      average_income_percent_temp: "20",
      average_income_yeary_temp: "",
      average_income_all_periods_temp: "400",
    };
  },
  computed: {
    self_help: function () {
      let m = this.average_income_yeary;
      if (!m) {
        m =
          (this.average_income_percent / 100) * this.average_income_all_periods;
      }
      return m;
    },
    self_help_monthly: function () {
      return Math.round((this.self_help / 12) * 10) / 10;
    },
    required_amount: function () {
      let r = this.self_help;
      let rate = 1 / (1 + this.expected_yield_during_reversal / 100);
      let y =
        this.expected_yield_during_reversal == 0
          ? this.final_age - this.end_age
          : (1 - rate ** (this.final_age - this.end_age)) /
            (this.expected_yield_during_reversal / 100);
      return Math.round(r * y);
    },
    percentage: function () {
      let rate = 1 / (1 + this.expected_yield_during_reversal / 100);
      let wRate = 1 / (1 + this.expected_yield / 100);
      let amount =
        this.expected_yield_during_reversal == 0
          ? this.required_amount
          : ((1 - rate ** (this.final_age - this.end_age)) * this.self_help) /
            (this.expected_yield_during_reversal / 100);
      //(1-$V$6^($C$5-$C$4))*IF(G5>0,G5,$G$4*$G$3)/$C$7
      let wYear =
        this.expected_yield == 0
          ? this.end_age - this.start_age
          : (wRate ** (this.start_age - this.end_age) - 1) /
            (this.expected_yield / 100);
      let prepared =
        ((this.retirement_funds / this.average_income_all_periods) *
          wRate ** (this.start_age - this.end_age)) /
        wYear;
      let result = amount / this.average_income_all_periods / wYear - prepared;
      return result;
    },
    target: function () {
      let result = Math.round(
        this.average_income_all_periods * this.percentage
      );
      if (!result) {
        result = 0;
      }
      return result;
    },
    target_monthly: function () {
      return Math.round((this.target / 12) * 10) / 10;
    },
    longevityWithout: function () {
      let age = this.end_age - this.start_age;
      let l =
        (age * this.target + Number(this.retirement_funds)) / this.self_help +
        this.end_age;
      let result = Math.round(l * 10) / 10;
      if (!result) {
        result = 0;
      }
      return result;
    },
    longevityWith: function () {
      return null;
    },
    income_in_reserve: function () {
      let income =
        this.required_amount -
        (this.end_age - this.start_age) * this.target -
        this.retirement_funds;
      return income;
    },
    income_under_reversal: function () {
      let income =
        this.self_help * (this.final_age - this.end_age) - this.required_amount;
      return income;
    },
    extended_years: function () {
      let y = this.final_age - this.longevityWithout;
      let result = Math.round(y * 10) / 10;
      if (result >= 100) {
        result = 0;
      }
      return result;
    },
    amount_array1: function () {
      let Arr = [
        18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35,
        36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53,
        54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71,
        72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89,
        90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100,
      ];
      for (let i = 0; i < Arr.length; i++) {
        let age = i + 18;
        if (age < this.start_age) {
          Arr[i] = 0;
        } else if (age < this.end_age + 1) {
          Arr[i] =
            Number(this.retirement_funds) +
            (age - this.start_age) * this.target;
        } else if (age < this.final_age + 1) {
          if (Arr[i - 1] - this.self_help < 0) {
            Arr[i] = 0;
          } else {
            Arr[i] = Arr[i - 1] - this.self_help;
          }
        } else {
          Arr[i] = 0;
        }
      }
      // console.log("amount_array1:", Arr);
      return Arr;
    },
    // =IF(N18<$C$3,0,
    // IF(N18<$C$4+1,$G$6+(N18-$C$3)*$E$13,
    // IF(N18<$C$5+1,IF(Q17-$U$3<0,0,Q17-$U$3),0)))
    amount_array2: function () {
      let Arr = [
        18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35,
        36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53,
        54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71,
        72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89,
        90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100,
      ];
      for (let i = 0; i < Arr.length; i++) {
        let age = i + 18;
        let rate = 1 / (1 + this.expected_yield_during_reversal / 100);
        let wRate = 1 / (1 + this.expected_yield / 100);
        let working_term =
          this.expected_yield == 0
            ? age - this.start_age
            : (wRate ** (this.start_age - age) - 1) /
              (this.expected_yield / 100);
        let retired_term =
          this.expected_yield_during_reversal == 0
            ? this.final_age - age
            : (1 - rate ** (this.final_age - age)) /
              (this.expected_yield_during_reversal / 100);
        if (age > this.final_age) {
          Arr[i] = 0;
        } else {
          if (age < this.start_age) {
            Arr[i] = 0;
          } else {
            if (age < this.end_age + 1) {
              Arr[i] = Math.round(
                this.percentage *
                  Number(this.average_income_all_periods) *
                  working_term +
                  Number(this.retirement_funds) *
                    wRate ** (this.start_age - age)
              );
            } else {
              //IF($G$5>0,$G$5,$G$4*$G$3)*IF($C$7=0,$C$5-N18,(1-$V$6^($C$5-$N18))/$C$7)
              Arr[i] = Math.round(this.self_help * retired_term);
            }
          }
        }
      }
      // console.log("Arr:", Arr);
      return Arr;
    },
    //IF(N18>$C$5,0,
    //IF(N18<$C$3,0,
    //IF(N18<$C$4+1,$U$4*$G$3*IF($C$6=0,N18-$C$3,($W$6^($C$3-N18)-1)/$C$6)+$G$6*$W$6^($C$3-$N18),IF($G$5>0,$G$5,$G$4*$G$3)*IF($C$7=0,$C$5-N18,(1-$V$6^($C$5-$N18))/$C$7))))
  },
  methods: {
    onFocus: function (type) {
      console.log("onFocus");
      if (type == "percent") {
        this.average_income_yeary_temp = "";
        this.radiochecked = "average_income_percent";
      } else if (type == "yeary") {
        this.average_income_percent_temp = "";
        this.radiochecked = "average_income_yeary";
      }
    },
    truncateDecimal: function (target, e) {
      console.log("target:", this[target], e.target.value);
      if (isNaN(e.target.value)) {
        this[target] = "";
      } else {
        // // 数字の場合は小数点第一位以下を切り捨てる
        // // return val.toString().replace(/(\.\d{1})\d+$/, "$1");
        this[target] = e.target.value.toString().replace(/(\.\d{1})\d+$/, "$1");
      }
    },
    truncateInteger: function (target, e) {
      console.log("truncateInteger:", e.target.value);
      if (isNaN(e.target.value)) {
        this[target] = 0;
      } else {
        // // 数字の場合は小数点第一位以下を切り捨てる
        // // return val.toString().replace(/(\.\d{1})\d+$/, "$1");
        if (e.target.value.toString().length > 6) {
          this[target] = Math.abs(
            Math.floor(Number(e.target.value.toString().substr(0, 6)))
          );
        } else {
          this[target] = Math.abs(Math.floor(e.target.value));
        }
      }
    },
    expect: function (e) {
      e.preventDefault();
      let r = true;
      let error_type = 0;
      if (
        this.expected_yield_temp == "" ||
        Number(this.expected_yield_temp) > 20
      ) {
        r = false;
        error_type = 1;
        this.error_target.push("expected_yield");
      }
      if (
        this.expected_yield_during_reversal_temp == "" ||
        Number(this.expected_yield_during_reversal_temp) > 20
      ) {
        r = false;
        error_type = 1;
        this.error_target.push("expected_yield_during_reversal");
      }
      if (this.retirement_funds_temp < 0) {
        r = false;
        this.error_target.push("retirement_funds");
      }
      console.log(
        "this.average_income_percent_temp:",
        this.average_income_percent_temp,
        this.average_income_percent_temp != ""
      );
      if (
        (Number(this.average_income_percent_temp) > 100 ||
          Number(this.average_income_percent_temp) < 1) &&
        this.radiochecked == "average_income_percent"
      ) {
        r = false;
        error_type = 2;
        this.error_target.push("average_income_percent");
      }
      if (
        this.average_income_percent_temp == "" &&
        this.average_income_yeary_temp == ""
      ) {
        r = false;
        this.error_target.push(
          "average_income_percent",
          "average_income_yeary"
        );
      }
      if (this.average_income_all_periods == "") {
        r = false;
        this.error_target.push("average_income_all_periods_temp");
      }
      if (r) {
        this.error = "";
        this.error_target = [];
        this.start_age = this.start_age_temp;
        this.end_age = this.end_age_temp;
        this.final_age = this.final_age_temp;
        this.expected_yield = this.expected_yield_temp;
        this.expected_yield_during_reversal =
          this.expected_yield_during_reversal_temp;
        this.retirement_funds = this.retirement_funds_temp;
        this.average_income_percent = this.average_income_percent_temp;
        this.average_income_yeary = this.average_income_yeary_temp;
        this.average_income_all_periods = this.average_income_all_periods_temp;

        this.$scrollTo("#expected");
      } else {
        this.error = this.error_text[error_type];
      }
    },
  },
};
</script>

<style>
#app {
}
</style>
